import { SET_REVIEWER_ID } from './';

export default id => ({ type: SET_REVIEWER_ID, payload: id });
